import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Import Data and Helpers
import { Articles as initialArticles  } from './Components/articleData';
import { truncateText } from './Components/utils';

// Import Child Components
import NewsHeader from './Components/NewsHeader';
import FeaturedArticles from './Components/FeaturedArticles';
import CategoryFilter from './Components/CategoryFilter';
import ArticleGrid from './Components/ArticleGrid';
import NewsletterSection from './Components/NewsletterSection';
import { typography } from './styles/minimalStyles';


// Sample Button Component (Replace with your actual Button if different)
const Button = ({ children, type = 'primary', ...props }) => {
  const buttonStyle = {
    padding: '10px 20px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    cursor: 'pointer',
    backgroundColor: type === 'secondary' ? '#eee' : '#007bff',
    color: type === 'secondary' ? '#333' : '#fff',
  };
  return <button style={buttonStyle} {...props}>{children}</button>;
}

const styles = {
  pageContainer: {
    fontFamily: typography.fontFamily, // Base font for the whole page
    // Add any overall page container styles if needed
  },
   // Removed sectionContainer styles as they are now part of individual components
   // Removed contentContainer styles as components use commonStyles.container
};

const NewsPage = () => {
  const navigate = useNavigate();
  const [recentArticles, setRecentArticles] = useState([]);
  const [remainingArticles, setRemainingArticles] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [categories, setCategories] = useState(['All']);
  const [filteredArticles, setFilteredArticles] = useState([]);

  // Remove parallaxRef, isVisible state and related useEffects for simplicity

  // Process articles, extract categories, and set up initial state
  useEffect(() => {
    const sortedArticles = [...initialArticles].sort((a, b) => new Date(b.date) - new Date(a.date));
    const recent = sortedArticles.slice(0, 3); // Keep first 3 as featured
    const remaining = sortedArticles.slice(3);

    setRecentArticles(recent);
    setRemainingArticles(remaining);

    const allCategories = ['All', ...new Set(sortedArticles.map(a => a.category).filter(Boolean))];
    setCategories(allCategories);
  }, []);

  // Filter articles when category changes
  useEffect(() => {
    // Simple filter without complex animations
    if (selectedCategory === 'All') {
      setFilteredArticles(remainingArticles);
    } else {
      const filtered = remainingArticles.filter(article => article.category === selectedCategory);
      setFilteredArticles(filtered);
    }
  }, [selectedCategory, remainingArticles]);


  // Handle news article navigation
  const handleNewsArticle = (articleHref) => {
     if (articleHref) {
        // Basic navigation, removed opacity transition for simplicity
        navigate(`/news/${articleHref}`); // Make sure '/news/' prefix is correct for your routes
     }
  };

  // Handle category selection
  const handleSelectCategory = (category) => {
      setSelectedCategory(category);
  };

  // Removed newsletter state and handlers, assuming NewsletterSignup handles it

  return (
    <div style={styles.pageContainer}>
      <NewsHeader
        title="News & Updates"
        description="Stay informed about our latest technological breakthroughs, research findings, and partnerships. Follow our journey in revolutionising plastic analysis and environmental monitoring."
      />

      <FeaturedArticles
        articles={recentArticles}
        onArticleClick={handleNewsArticle}
      />

      {/* Assuming NewsletterSignup is self-contained */}
      <NewsletterSection />

      <CategoryFilter
        categories={categories}
        selectedCategory={selectedCategory}
        onSelectCategory={handleSelectCategory}
      />

      <ArticleGrid
        articles={filteredArticles}
        onArticleClick={handleNewsArticle}
        category={selectedCategory} // Pass category for "no results" message
      />

      {/* Optional Load More Button */}
      {/* Implement load more logic if needed */}
      {/*
      {filteredArticles.length > SOME_LIMIT && (
          <div style={{ textAlign: 'center', margin: '40px 0' }}>
              <Button type="secondary" onClick={() => // console.log'Load More clicked')}>
                  Load More Articles
              </Button>
          </div>
      )}
      */}
    </div>
  );
};

export default NewsPage;